import React from 'react';
import { Helmet } from 'react-helmet';
import PropTypes from 'prop-types';
import Topbar from '../../PulseSurvey/Topbar';
import PeapInsights from './PeapInsights';
import { PeapDashboardData } from '../../../utils/pageContent';

/**
 * PEAP dashboard page. The content is PeapInsights; this is only the page
 * chrome, and `topbarShow` lets the page be embedded in a tab without a
 * second top bar.
 */
const PeapDashboard = ({ topbarShow = true }) => (
  <div className="relative lg:mb-[45px]">
    <Helmet>
      <meta charSet="utf-8" />
      <title>{PeapDashboardData.metaTitle}</title>
    </Helmet>
    {topbarShow ? <Topbar title={PeapDashboardData.title} /> : null}
    <PeapInsights />
  </div>
);

PeapDashboard.propTypes = {
  topbarShow: PropTypes.bool
};

export default PeapDashboard;
